export default class Message
{
    constructor(message = {})
    {
        this.message = message;
    }

    handle()
    {

    }
}
